// v10/src/hooks/useInspection.js
import { useState } from 'react';
import { inspectionService } from '../services/apiService';
import { useOfflineQueue } from './useOfflineQueue';

export const useInspection = () => {
  const [isSaving,    setIsSaving]    = useState(false);
  const [saveError,   setSaveError]   = useState(null);
  const [saveSuccess, setSaveSuccess] = useState(false);
  // ✅ FIX 3: true cuando se guardó en la cola offline (no en el servidor)
  const [savedOffline, setSavedOffline] = useState(false);

  const { enqueue } = useOfflineQueue();

  const saveInspection = async (inspectionData) => {
    setIsSaving(true);
    setSaveError(null);
    setSaveSuccess(false);
    setSavedOffline(false);

    // ✅ FIX 3: si no hay conexión, encolar localmente y retornar sin error
    if (!navigator.onLine) {
      const queueId = enqueue(inspectionData);
      setSavedOffline(true);
      setIsSaving(false);
      console.info('[useInspection] Sin conexión — inspección encolada:', queueId);
      // Retornamos un objeto simulado para que CompletionScreen no rompa
      return { queued: true, queueId };
    }

    try {
      const response = await inspectionService.create(inspectionData);
      if (response.data.success) {
        setSaveSuccess(true);
        return response.data.data;
      } else {
        throw new Error('Error al guardar la inspección');
      }
    } catch (error) {
      // ✅ FIX 3: si el error es de red (no de validación), encolar para reintentar
      const isNetworkError = !error.response || error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED';
      if (isNetworkError) {
        const queueId = enqueue(inspectionData);
        setSavedOffline(true);
        setIsSaving(false);
        console.info('[useInspection] Error de red — inspección encolada:', queueId);
        return { queued: true, queueId };
      }

      console.error('Error guardando inspección:', error);
      setSaveError(error.response?.data?.message || 'Error al guardar la inspección');
      throw error;
    } finally {
      setIsSaving(false);
    }
  };

  const uploadPhoto = async (inspectionId, photoFile, itemId = null) => {
    try {
      const response = await inspectionService.uploadPhoto(inspectionId, photoFile, itemId);
      return response.data;
    } catch (error) {
      console.error('Error subiendo foto:', error);
      throw error;
    }
  };

  const getInspections = async (filters = {}) => {
    try {
      const response = await inspectionService.getAll(filters);
      return response.data;
    } catch (error) {
      console.error('Error obteniendo inspecciones:', error);
      throw error;
    }
  };

  const getInspectionById = async (id) => {
    try {
      const response = await inspectionService.getById(id);
      return response.data;
    } catch (error) {
      console.error('Error obteniendo inspección:', error);
      throw error;
    }
  };

  return {
    saveInspection,
    uploadPhoto,
    getInspections,
    getInspectionById,
    isSaving,
    saveError,
    saveSuccess,
    savedOffline, // ✅ nuevo — para que CompletionScreen lo muestre
  };
};
